export const notificationQueryKeys = {
  all: ['notifications'] as const,
} as const;
